import { render, staticRenderFns } from "./ProfileToday.vue?vue&type=template&id=a3e33876&"
import script from "./ProfileToday.vue?vue&type=script&lang=js&"
export * from "./ProfileToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports